import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"

export const getWarrantStatus = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const warrantStatusQuery = AccountService.getWarrantStatus(coreIdQuery.data)

  queries.add(coreIdQuery)
  queries.add(warrantStatusQuery)

  return queries.setData(warrantStatusQuery.data).getAggregate()
}
